import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/calibration-management')({
  component: CalibrationManagementLayout,
});

function CalibrationManagementLayout() {
  return <Outlet />;
}
